<template>
  <button-base :channel="channel" :show-button-labels="showButtonLabels" icon-class="icon-mail" @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import EmailMixin from '@/share/campaign/email-mixin'

export default {
  components: { ButtonBase },

  mixins: [EmailMixin],

  props: {
    channel: {
      type: Object,
      required: true
    },

    showButtonLabels: {
      type: Boolean,
      required: true
    }
  }
}
</script>
